export default "__VITE_ASSET__af0289fe__"